export default "/_next/static/images/garrett-smallwood-f5779a56fad49d222451d3841e3599de.png";